<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9,0C9,0,3,0,3,0C2.45,0,2,0.45,2,1C2,1,2,15,2,15C2,15.55,2.45,16,3,16C3,16,13,16,13,16C13.55,16,14,15.55,14,15C14,15,14,5,14,5C14,5,9,0,9,0C9,0,9,0,9,0ZM12,14C12,14,4,14,4,14C4,14,4,2,4,2C4,2,8,2,8,2C8,2,8,6,8,6C8,6,12,6,12,6C12,6,12,14,12,14C12,14,12,14,12,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Document',
} as DefineComponent
</script>
